import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from "lucide-react";
import Loader from '../../../components/UI/Loader/Loader';
import Activation from '../../../components/BulkActivation/Activation';
import { permission } from '../../../config/permission';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import Button from '../../../components/UI/Button';

const BulkActivation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { experiences } = location.state || {};
    const { content } = useContentfulContext();

    const [isLoading, setIsLoading] = useState(false);
    const [validationError, setValidationError] = useState("");

    useEffect(() => {
        if (!experiences || !experiences?.length) {
            navigate('/experience/manage-experiences');
        }
    }, [experiences, navigate]);

    return (
        <div className="stride-page-shell">
            {isLoading && <Loader />}
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <Button
                        variant="ghost"
                        size="sm"
                        icon={<ArrowLeft size={16} />}
                        onClick={() => navigate("/experience/manage-experiences")}
                        aria-label="Back to Experiences"
                    />
                    <div>
                        <span className="stride-eyebrow">Experiences / Bulk Operations</span>
                        <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
                            {content?.BULK_ACTIVATION_CONTENT?.title || "Bulk Activation"}
                        </h1>
                    </div>
                </div>

                <Activation
                    experiences={experiences} 
                    validationError={validationError}
                    offerPermission={{
                        create: permission.CREATE_EXP_OP_CREATE_OFFER,
                        edit: permission.CREATE_EXP_OP_EDIT_OFFER
                    }}
                />
            </div>
        </div>
    );
};

export default BulkActivation;
